module.exports = __webpack_public_path__ + "static/media/calendar.5900f69f.svg";